import React from 'react';
import { Icon } from './Icon';
import './ProgressTracker.scss';

type Data = {
  id: number;
  label?: string;
  completed: boolean;
  current: boolean;
  error?: boolean;
  inactive: boolean;
};

interface ProgressTrackerProps {
  data: Data[];
  labels?: boolean | string;
  numbers?: boolean;
}

export const ProgressTracker: React.FC<ProgressTrackerProps> = ({
  data,
  labels,
  numbers
}) => {
  return numbers ? (
    <ul className="ads-progress-tracker" data-testid="ads-progress-tracker">
      {data.map((step) => (
        <li
          className={`ads-progress-tracker__item `}
          key={step.id}
          data-testid="ads-progress-tracker__item"
        >
          <div className="ads-progress-tracker__bar">
            <div
              className={`ads-progress-tracker__bar--left ${
                step.current ? 'ads-bar-blade' : ''
              } ${
                step.completed
                  ? 'ads-progress-tracker__bar--completed'
                  : 'ads-progress-tracker__bar--inactive '
              }`}
            />

            {step.error ? (
              <Icon name="error" ariaLabel="error" />
            ) : step.completed ? (
              <Icon
                iconText={`${step.id}`}
                name="number-solid"
                data-testid="ads-progress-tracker__icon"
              />
            ) : step.current ? (
              <Icon iconText={`${step.id}`} name="number" />
            ) : (
              <Icon name="blank" />
            )}

            <div
              className={`ads-progress-tracker__bar--right ${
                step.completed
                  ? 'ads-progress-tracker__bar--completed'
                  : 'ads-progress-tracker__bar--inactive '
              }`}
            />
          </div>
          {labels && (
            <div
              aria-disabled={step.current ? 'false' : 'true'}
              className={`${
                step.current
                  ? 'ads-progress-tracker__label'
                  : 'ads-progress-tracker__label ads-progress-tracker__label--disabled'
              }`}
              data-testid="ads-progress-tracker__label"
            >
              {step.label}
            </div>
          )}
        </li>
      ))}
    </ul>
  ) : (
    <ul className="ads-progress-tracker" data-testid="ads-progress-tracker">
      {data.map((step) => (
        <li className={`ads-progress-tracker__item `} key={step.id}>
          <div className="ads-progress-tracker__bar">
            <div
              className={`ads-progress-tracker__bar--left ${
                step.current ? 'ads-bar-blade' : ''
              } ${
                step.completed
                  ? 'ads-progress-tracker__bar--completed'
                  : 'ads-progress-tracker__bar--inactive '
              }`}
            />

            {step.error ? (
              <Icon name="error" />
            ) : step.completed ? (
              <Icon name="success" />
            ) : step.current ? (
              <Icon name="current" />
            ) : (
              <Icon name="blank" />
            )}

            <div
              className={`ads-progress-tracker__bar--right ${
                step.completed
                  ? 'ads-progress-tracker__bar--completed'
                  : 'ads-progress-tracker__bar--inactive '
              }`}
            />
          </div>

          {labels && (
            <div
              aria-disabled={step.current ? 'false' : 'true'}
              className={`${
                step.current
                  ? 'ads-progress-tracker__label'
                  : 'ads-progress-tracker__label ads-progress-tracker__label--disabled'
              }`}
              data-testid="ads-progress-tracker__label"
            >
              {step.label}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
};
